module.exports = __webpack_public_path__ + "static/media/img_hero-define-2.c50827de.png";